import { DateTime } from 'luxon';

export const NinetyDaysAgo = (date: Date) =>
  DateTime.fromJSDate(date).minus({ days: 90 }).toJSDate();



